/** 修改手机号模态窗 */
import * as React from 'react';
import { Button, Form, Icon, Tag, Input, Popconfirm, Row, Upload, message, DatePicker, Checkbox } from 'antd';
import I18N from 'src/services/I18NService';
import WalletService, { IAccountEditRecord, IAccountEditRecordResult, IAccountInfo } from 'src/services/WalletService';
import '../views/Wallet/wallet.css';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import moment from 'moment';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import FlexApiService, { IBucketInfo } from 'src/services/FlexApiService';

// 身份证的正则表达式
const SID_REG = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;

interface IFormProps extends FormComponentProps {
  /** 开户账号信息 */
  account: IAccountInfo;
  /** 记录 */
  examineRecord?: IAccountEditRecordResult | undefined;
  isReadonly: boolean;
  closeModal(): void;
  submitEditInfo(): void;
}

interface IFormState {
  /** 是否正在提交 */
  isLoading: boolean;
  disableEndDate: boolean;
  nameEdit: boolean;
  legalNameEdit: boolean;
  legalPhoneEdit: boolean;
  identityNoEdit: boolean;
  idBackEdit: boolean;
  businessLicenseEdit: boolean;
  idFrontEdit: boolean;
  beginDateEdit: boolean;
  endDateEdit: boolean;
}

/**
 * 创建修改账户Form组件
 */
class CreateEditAccountForm extends React.Component<IFormProps, IFormState> {
  private walletService = WalletService;
  private bucket: IBucketInfo | undefined;
  private flexService = FlexApiService;
  constructor(props: IFormProps) {
    super(props);
    this.state = {
      isLoading: false,
      disableEndDate: false,
      nameEdit: false,
      legalNameEdit: false,
      legalPhoneEdit: false,
      identityNoEdit: false,
      idBackEdit: false,
      businessLicenseEdit: false,
      idFrontEdit: false,
      beginDateEdit: false,
      endDateEdit: false,
    };
  }

  componentDidMount() {
    this.checkDifferent();

    // TODO:@le 是否存在更新记录
  }

  checkDifferent() {
    const { account, isReadonly, examineRecord } = this.props;
    const { setFieldsValue } = this.props.form;
    const beginDate = account.identity_begin_date ? moment(account.identity_begin_date, 'YYYY-MM-DD') : undefined;
    const endDate = account.identity_end_date
      ? account.identity_end_date === '9999-12-31'
        ? undefined
        : moment(account.identity_end_date, 'YYYY-MM-DD')
      : undefined;
    let nameEdit = false;
    let legalNameEdit = false;
    let legalPhoneEdit = false;
    let identityNoEdit = false;
    let idBackEdit = false;
    let businessLicenseEdit = false;
    let idFrontEdit = false;
    let beginDateEdit = false;
    let endDateEdit = false;
    let name = account.name;
    let legal_name = account.legal_name;
    let legal_phone = account.legal_phone;
    let identity_no = account.identity_no;
    let pic_id_card_back = account.pic_id_card_back;
    let pic_business_license = account.pic_business_license;
    let pic_id_card_front = account.pic_id_card_front;
    let identity_begin_date = beginDate;
    let identity_end_date = endDate;
    let disableEndDate = false;
    if (account.identity_end_date === '9999-12-31') {
      disableEndDate = true;
    }
    if (isReadonly && examineRecord && examineRecord.status === 'PENDING') {
      if (account.name !== examineRecord.details.name) {
        nameEdit = true;
        name = examineRecord.details.name;
      }
      if (account.legal_name !== examineRecord.details.legal_name) {
        legalNameEdit = true;
        legal_name = examineRecord.details.legal_name;
      }
      if (account.legal_phone !== examineRecord.details.legal_phone) {
        legalPhoneEdit = true;
        legal_phone = examineRecord.details.legal_phone;
      }
      if (account.identity_no !== examineRecord.details.identity_no) {
        identityNoEdit = true;
        identity_no = examineRecord.details.identity_no;
      }
      if (account.identity_begin_date !== examineRecord.details.identity_begin_date) {
        beginDateEdit = true;
        const beginDateExamine = examineRecord.details.identity_begin_date;
        identity_begin_date = beginDateExamine ? moment(beginDateExamine, 'YYYY-MM-DD') : undefined;
      }
      if (account.identity_end_date !== examineRecord.details.identity_end_date) {
        endDateEdit = true;
        if (examineRecord.details.identity_end_date === '9999-12-31') {
          disableEndDate = true;
        }
        const endDateExamine = examineRecord.details.identity_end_date;
        identity_end_date = endDateExamine ? (endDateExamine === '9999-12-31' ? undefined : moment(endDateExamine, 'YYYY-MM-DD')) : undefined;
      }

      if (decodeURI(account.pic_business_license || '') !== decodeURI(examineRecord.details.pic_business_license || '')) {
        businessLicenseEdit = true;
        pic_business_license = examineRecord.details.pic_business_license;
      }
      if (decodeURI(account.pic_id_card_front || '') !== decodeURI(examineRecord.details.pic_id_card_front || '')) {
        idFrontEdit = true;
        pic_id_card_front = examineRecord.details.pic_id_card_front;
      }

      if (decodeURI(account.pic_id_card_back || '') !== decodeURI(examineRecord.details.pic_id_card_back || '')) {
        idBackEdit = true;
        pic_id_card_back = examineRecord.details.pic_id_card_back;
      }
    }

    this.setState({
      nameEdit,
      legalNameEdit,
      legalPhoneEdit,
      identityNoEdit,
      idBackEdit,
      businessLicenseEdit,
      idFrontEdit,
      beginDateEdit,
      endDateEdit,
      disableEndDate,
    });
    setFieldsValue({
      name,
      legal_name,
      legal_phone,
      identity_no,
      pic_id_card_back,
      pic_business_license,
      pic_id_card_front,
      identity_begin_date,
      identity_end_date,
    });
  }

  sidValidator = (rule: any, value: string, callback: any) => {
    const { isReadonly } = this.props;
    if (!SID_REG.test(value) && !isReadonly) {
      callback('请输入15位或18位身份证号码');
    } else {
      callback();
    }
  };

  disabledStartDate = (fieldStartValue: moment.Moment | null) => {
    if (!fieldStartValue) {
      return false;
    }
    const fieldEndValue = this.props.form.getFieldValue('identity_end_date') as moment.Moment;
    // 计算零点时间
    const startValue = moment(fieldStartValue.format('YYYY-MM-DD'), 'YYYY-MM-DD');
    const endValue = fieldEndValue ? moment(fieldEndValue.format('YYYY-MM-DD'), 'YYYY-MM-DD') : moment('9999-12-31', 'YYYY-MM-DD');
    return startValue.valueOf() >= endValue.valueOf();
  };

  disabledEndDate = (fieldEndValue: moment.Moment | null) => {
    const fieldStartValue = this.props.form.getFieldValue('identity_begin_date');
    if (!fieldEndValue || !fieldStartValue) {
      return false;
    }
    // 计算零点时间
    const startValue = moment(fieldStartValue.format('YYYY-MM-DD'), 'YYYY-MM-DD');
    const endValue = moment(fieldEndValue.format('YYYY-MM-DD'), 'YYYY-MM-DD');
    return endValue.valueOf() <= startValue.valueOf();
  };

  endDateValidator = (rule: any, value: string, callback: any) => {
    const { isReadonly } = this.props;
    if (!value && !this.state.disableEndDate && !isReadonly) {
      callback('请输入证件有效截止日期');
    } else {
      callback();
    }
  };

  handleEndDateCheck = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked;
    this.props.form.setFieldsValue({ identity_end_date: null });
    this.setState(
      {
        disableEndDate: checked,
      },
      () => {
        this.props.form.validateFields(['identity_end_date'], { force: true });
      }
    );
  };

  submitEditForm = (e?: React.SyntheticEvent) => {
    e && e.preventDefault();
    this.props.form.validateFields(async (err, values: IAccountEditRecord) => {
      if (!err) {
        const { account } = this.props;
        const params: Partial<IAccountEditRecord> = {};
        if (values.name !== account.name) {
          params.name = values.name;
        }

        if (values.legal_name !== account.legal_name) {
          params.legal_name = values.legal_name;
        }
        if (values.legal_phone !== account.legal_phone) {
          params.legal_phone = values.legal_phone;
        }
        if (values.identity_no !== account.identity_no) {
          params.identity_no = values.identity_no;
        }
        if (values.pic_id_card_back !== account.pic_id_card_back) {
          params.pic_id_card_back = values.pic_id_card_back;
        }
        if (values.pic_business_license !== account.pic_business_license) {
          params.pic_business_license = values.pic_business_license;
        }
        if (values.pic_id_card_front !== account.pic_id_card_front) {
          params.pic_id_card_front = values.pic_id_card_front;
        }
        const vStartDate = values.identity_begin_date ? moment(values.identity_begin_date, 'YYYY-MM-DD') : undefined;
        const aStartDate = account.identity_begin_date ? moment(account.identity_begin_date, 'YYYY-MM-DD') : undefined;
        if (vStartDate?.format('YYYY-MM-DD') !== aStartDate?.format('YYYY-MM-DD')) {
          const startDate = values.identity_begin_date ? (values.identity_begin_date as unknown as moment.Moment).format('YYYY-MM-DD') : '';
          params.identity_begin_date = startDate;
        }

        const vEndDate = values.identity_end_date
          ? values.identity_end_date === '9999-12-31'
            ? undefined
            : moment(values.identity_end_date, 'YYYY-MM-DD')
          : undefined;
        const aEndDate = account.identity_end_date
          ? account.identity_end_date === '9999-12-31'
            ? undefined
            : moment(account.identity_end_date, 'YYYY-MM-DD')
          : undefined;
        if (vEndDate?.format('YYYY-MM-DD') !== aEndDate?.format('YYYY-MM-DD')) {
          // 截至时间为空 取 9999-12-31
          const endDate = values.identity_end_date
            ? (values.identity_end_date as unknown as moment.Moment).format('YYYY-MM-DD')
            : moment('9999-12-31', 'YYYY-MM-DD').format('YYYY-MM-DD');
          params.identity_end_date = endDate;
        }
        if (JSON.stringify(params) !== '{}') {
          const res = await this.walletService.updateEnterpriseAccountInfo(params);
          if (res.status) {
            this.props.submitEditInfo();
            this.props.closeModal();
          } else {
            message.error(res.msg);
          }
        } else {
          message.warn('无修改信息， 无须提交');
        }
      }
    });
  };

  render() {
    const formItemLayout: FormItemProps = {
      labelCol: { span: 7 },
      wrapperCol: { span: 15 },
    };
    const { isReadonly } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      isLoading,
      disableEndDate,
      nameEdit,
      legalNameEdit,
      legalPhoneEdit,
      identityNoEdit,
      idBackEdit,
      businessLicenseEdit,
      idFrontEdit,
      beginDateEdit,
      endDateEdit,
    } = this.state;
    const helpText = '请检查确认信息无误(15位或18位身份证号码)，每天最多只能提交5次';
    const editText = <Tag color="orange">已修改</Tag>;

    const formItems: JSX.Element[] = [];
    formItems.push(
      <Form.Item label={'企业名称'} {...formItemLayout} help={isReadonly && nameEdit ? editText : ''} key={'name'}>
        {getFieldDecorator(`name`, {
          rules: [
            {
              required: !isReadonly,
              message: `请输入企业全称`,
            },
          ],
          initialValue: null,
        })(<Input disabled={isReadonly} placeholder={`请输入企业全称`} />)}
      </Form.Item>
    );
    formItems.push(
      <Form.Item label={I18N.get('common_name')} {...formItemLayout} key={'legal_name'} help={isReadonly && legalNameEdit ? editText : ''}>
        {getFieldDecorator(`legal_name`, {
          rules: [
            {
              required: !isReadonly,
              message: `请输入法人姓名`,
            },
          ],
          initialValue: null,
        })(<Input disabled={isReadonly} placeholder={`请输入法人姓名`} />)}
      </Form.Item>
    );

    formItems.push(
      <Form.Item label={'法人手机号'} {...formItemLayout} key={'legal_phone'} help={isReadonly && legalPhoneEdit ? editText : ''}>
        {getFieldDecorator(`legal_phone`, {
          rules: [
            {
              required: !isReadonly,
              message: `${I18N.get('common_input')}${I18N.get('common_mobile')}`,
            },
            {
              pattern: /\d{11}/,
              message: `请输入11位手机号码`,
            },
          ],
          initialValue: null,
        })(<Input disabled={isReadonly} placeholder={`请输入法人手机号码`} />)}
      </Form.Item>
    );

    formItems.push(
      <Form.Item label={'证件号'} key={'identity_no'} help={isReadonly && identityNoEdit ? editText : isReadonly ? '' : helpText} {...formItemLayout}>
        {getFieldDecorator('identity_no', {
          rules: [
            {
              required: !isReadonly,
              message: `${I18N.get('common_input')}${'证件号'}`,
            },
            {
              validator: this.sidValidator,
            },
          ],
          initialValue: null,
        })(<Input disabled={isReadonly} placeholder={`${I18N.get('common_input')}`} />)}
      </Form.Item>
    );

    formItems.push(
      <Form.Item label={'证件有效开始日期'} {...formItemLayout} key={'identity_start_date'} help={isReadonly && beginDateEdit ? editText : ''}>
        {getFieldDecorator('identity_begin_date', {
          initialValue: null,
          rules: [
            {
              required: !isReadonly,
              message: '请填写证件有效开始日期',
            },
          ],
        })(
          <DatePicker
            disabled={isReadonly}
            style={{ width: '100%' }}
            showToday={false}
            disabledDate={this.disabledStartDate}
            format="YYYY-MM-DD"
            placeholder="开始日期"
          />
        )}
      </Form.Item>
    );

    formItems.push(
      <Form.Item required={true} label={'证件有效截止日期'} {...formItemLayout} key={'identity_end_date'} help={isReadonly && endDateEdit ? editText : ''}>
        <Row type="flex" align="middle">
          {getFieldDecorator('identity_end_date', {
            initialValue: null,
            rules: [
              {
                validator: this.endDateValidator,
              },
            ],
          })(
            <DatePicker
              disabled={disableEndDate || isReadonly}
              style={{ flex: '1 1 auto' }}
              showToday={false}
              disabledDate={this.disabledEndDate}
              format="YYYY-MM-DD"
              placeholder="截止日期"
            />
          )}
          <Checkbox style={{ marginLeft: 8 }} disabled={isReadonly} checked={disableEndDate} onChange={this.handleEndDateCheck}>
            长期
          </Checkbox>
        </Row>
      </Form.Item>
    );

    const uploadButton = (
      <div>
        <Icon type={'plus'} />
        <div className="ant-upload-text">上传</div>
      </div>
    );

    const imageUrl = getFieldValue('pic_business_license');
    formItems.push(
      <Form.Item label={'营业执照'} {...formItemLayout} key={'pic_business_license'} help={isReadonly && businessLicenseEdit ? editText : ''}>
        {getFieldDecorator(`pic_business_license`, {
          initialValue: null,
          rules: [
            {
              required: !isReadonly,
              message: '请上传营业执照',
            },
          ],
        })(
          <Upload
            disabled={isReadonly}
            listType="picture-card"
            className="license-uploader"
            showUploadList={false}
            beforeUpload={(file: File) => {
              this.uploadFile(file, 'pic_business_license');
              return false;
            }}
          >
            {imageUrl ? <img src={imageUrl} style={{ width: '100%' }} /> : uploadButton}
          </Upload>
        )}
      </Form.Item>
    );

    const imageUrl1 = getFieldValue('pic_id_card_front');
    formItems.push(
      <Form.Item label={'身份证正面照'} {...formItemLayout} key={'pic_id_card_front'} help={isReadonly && idFrontEdit ? editText : ''}>
        {getFieldDecorator(`pic_id_card_front`, {
          initialValue: null,
          rules: [
            {
              required: !isReadonly,
              message: '请上身份证正面照',
            },
          ],
        })(
          <Upload
            disabled={isReadonly}
            listType="picture-card"
            className="license-uploader"
            showUploadList={false}
            beforeUpload={(file: File) => {
              this.uploadFile(file, 'pic_id_card_front');
              return false;
            }}
          >
            {imageUrl1 ? <img src={imageUrl1} style={{ width: '100%' }} /> : uploadButton}
          </Upload>
        )}
      </Form.Item>
    );

    const imageUrl2 = getFieldValue('pic_id_card_back');
    formItems.push(
      <Form.Item label={'身份证背面照'} {...formItemLayout} key={'pic_id_card_back'} help={isReadonly && idBackEdit ? editText : ''}>
        {getFieldDecorator(`pic_id_card_back`, {
          initialValue: null,
          rules: [
            {
              required: !isReadonly,
              message: '请上身份证背面照',
            },
          ],
        })(
          <Upload
            disabled={isReadonly}
            listType="picture-card"
            className="license-uploader"
            showUploadList={false}
            beforeUpload={(file: File) => {
              this.uploadFile(file, 'pic_id_card_back');
              return false;
            }}
          >
            {imageUrl2 ? <img src={imageUrl2} style={{ width: '100%' }} /> : uploadButton}
          </Upload>
        )}
      </Form.Item>
    );
    if (!isReadonly) {
      formItems.push(
        <Form.Item key={'submit'} wrapperCol={{ span: 12, offset: 7 }}>
          <Popconfirm
            overlayClassName="modify-enterprise-popover"
            title="您变更了用户资料，在资料变更成功前，您仍可按照当前资料进行操作，该变更不可撤销，请您谨慎处理 ！"
            onConfirm={(e) => this.submitEditForm(e)}
            okText={'确认提交'}
            cancelText={I18N.get('common_cancel')}
          >
            <Button type="primary" htmlType="submit" loading={isLoading}>
              {I18N.get('common_submit')}
            </Button>
          </Popconfirm>
        </Form.Item>
      );
    }
    return <Form>{formItems}</Form>;
  }

  private async uploadFile(file: File, name: string) {
    try {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('抱歉，只能上传JPG或PNG图片!');
        return;
      }
      let bucket = this.bucket;
      if (!bucket) {
        this.bucket = await this.flexService.createBucket({
          bucket_type: 'mc_wallet_pic',
          intro: { name: 'macrocura wallet register pictures' },
        });
        bucket = this.bucket;
      }
      if (!!bucket) {
        const res = await this.flexService.uploadJumpLinkPic(bucket, file);
        if (!!res) {
          this.props.form.setFieldsValue({ [name]: res });
          // onSuccess(res, file);
        } else {
          message.error('上传照片失败了!');
        }
      } else {
        message.error('上传照片失败了!');
      }
    } catch (error) {
      message.error('出错了');
    }
  }
}
export const ModifyAccountForm = Form.create<IFormProps>()(CreateEditAccountForm);



// WEBPACK FOOTER //
// ./src/components/common/ModifyAccountForm.tsx